export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/python.b14246e.svg";